import { createAction } from "redux-actions";
import { PAGE_SIZE_10 } from "../../constants/index";
import { apiPost, apiGet, apiDelete, apiPut } from "../../api/index";
import {
  urlInventarySecured,
  urlExportInventarySecured,
  urlOnlyInventarySecured,
} from "../../api/urls";
import moment from "moment-timezone";

const generateInventaryFilterQuery = ({ filters, page, pageSize, sort }) => {
  let filter = "?";

  page ? (filter += "page=" + page) : (filter += "page=1");
  pageSize
    ? (filter += "&pageSize=" + pageSize)
    : (filter += "&pageSize=" + PAGE_SIZE_10);

  if (filters) {
    if (filters.status) filter += "&status=" + filters.status;
    if (filters.batch) filter += "&batch=" + filters.batch;
    if (filters.dateInit) {
      const dateInit = moment(filters.dateInit);
      filter += "&dateInit=" + dateInit.valueOf();
    }
    if (filters.dateEnd) {
      const dateEnd = moment(filters.dateEnd);
      filter += "&dateEnd=" + dateEnd.valueOf();
    }
  }

  if (sort) filter += "&sort=" + sort;

  return filter;
};

/**
 * Filter list stock.
 */
export const filterInventary = createAction(
  "FILTER_INVENTARY",
  (filter, param) =>
    apiGet(
      urlInventarySecured + generateInventaryFilterQuery(filter),
      param,
      true
    )()
);

/**
 * Export Inventary.
 */
export const listInventaryToExport = createAction(
  "EXPORT_FILTER_INVENTARY",
  (param) => apiGet(urlExportInventarySecured, param, true)()
);

export const createInventary = createAction("CREATE_INVENTARY", () =>
  apiPost(urlInventarySecured, undefined, undefined, true)()
);

export const inventaryNew = createAction("CREATE_INVENTARY", (obj) =>
  apiPost(urlOnlyInventarySecured, obj, undefined, true)()
);

export const getProcess = createAction("GET_PROCESS", (param) =>
  apiGet(urlInventarySecured, param, true)()
);

export const modifyProcess = createAction("CREATE_INVENTARY", (param) =>
  apiPut(urlInventarySecured, undefined, param, true)()
);



